import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";

import AuthContext from  "../context/AuthContext";

const PrivateRoute = () => {
    const { user } = useContext(AuthContext);
    const authUser = localStorage.getItem('authTokens')

    // console.log('private user:',user)
    // console.log('private auth:', authUser)


    if (typeof user === "undefined"){
        return null;
    }
    // else if(user?.user_id){
    //     return <Outlet />;
    // }
    return authUser ? <Outlet /> : <Navigate to='/login' />
};
 
export default PrivateRoute;
